<div class="left-col">
  <mat-tab-group
    dynamicHeight
    color="accent"
    (selectedTabChange)="tabChanged($event)"
    [selectedIndex]="editor.activeTab$ | async"
    animationDuration="0"
  >
    <mat-tab [label]="'Content' | trans">
      <ng-template matTabContent>
        <biolink-editor-content class="left-col-spacer"></biolink-editor-content>
      </ng-template>
    </mat-tab>
    <mat-tab [label]="'Appearance' | trans">
      <ng-template matTabContent>
        <biolink-appearance class="left-col-spacer"></biolink-appearance>
      </ng-template>
    </mat-tab>
    <mat-tab [label]="'Settings' | trans">
      <ng-template matTabContent>
        <biolink-settings class="left-col-spacer"></biolink-settings>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
</div>
<div class="right-col">
  <div class="preview-title" *ngIf="editor.biolink$ | async as biolink">
    <div class="link">
      <a [href]="biolink.short_url" target="_blank">{{biolink.short_url}}</a>
    </div>
    <share-link-btns [showCopyBtn]="true" [colored]="true" [link]="biolink"></share-link-btns>
  </div>
  <div class="phone-preview">
    <biolink-page
      [biolink]="editor.biolink$ | async"
      [appearance]="appearance$ | async"
    ></biolink-page>
  </div>
</div>
